import {useAuth, usePermission} from "@/lib/auth";
type ActivityRole={id:string;name?:string|null;workspaceId?:string|null};
/** Role identity must match staffFinanceRole, not Step18 (which also allows area managers). */
export function staffActivityRole(role:ActivityRole|null|undefined,workspaceId:string|undefined){
  if(!role||!workspaceId||(role.workspaceId&&role.workspaceId!==workspaceId))return false;
  if(["area_manager","branch_manager","location_manager"].includes(role.id))return false;
  return ["admin","system_admin","finance_manager"].includes(role.id)||
    (role.workspaceId===workspaceId&&["admin","administrator","system admin","owner","finance manager"].includes(role.name?.trim().toLowerCase()||""));
}
export function useStaffActivityAccess(){
  const {user,roles,currentWorkspace}=useAuth();
  const staff=usePermission("employees.view"),viewCash=usePermission("branch_cash.view"),manageCash=usePermission("branch_cash.manage");
  return staff&&viewCash&&manageCash&&staffActivityRole(roles?.find(r=>r.id===user?.roleId),currentWorkspace?.id);
}
